import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import styles from './ModelWithDescription.css';
const ModelWithDescription = ({ description, name = '', nameWithSubscript = '', }) => (_jsxs("div", Object.assign({ className: styles.container }, { children: [nameWithSubscript
            ? (_jsx("div", { className: styles.name, dangerouslySetInnerHTML: { __html: nameWithSubscript } }, void 0))
            : (_jsx("div", Object.assign({ className: styles.name }, { children: name }), void 0)), description && _jsx("div", Object.assign({ className: styles.description }, { children: description }), void 0)] }), void 0));
export default memo(ModelWithDescription);
